import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import {
	getAssetDocuments,
	getAssetDrawingAssemblies,
} from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsAssetDocumentsLoading: (isLoading: boolean) => void;
	setAssetDocumentsError: (err: string) => void;
};

export const useSearchAssetDocuments = ({
	setIsAssetDocumentsLoading,
	setAssetDocumentsError,
}: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetDocuments },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setIsAssetDocumentsLoading(true);
		const [res, asmRes] = await Promise.all([
			getAssetDocuments(assetSearchId, includeDescendants),
			getAssetDrawingAssemblies(assetSearchId, includeDescendants),
		]);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			// Group assemblies by document name so each drawing row can carry the assemblies that
			// contain it (drives the in-row assembly indicator). Non-fatal if the map call fails.
			const asmRows = asmRes.ok ? get(asmRes, "data.tables[0].rows", []) : [];
			const byDoc = new Map<string, any[]>();
			for (const a of asmRows) {
				const key = String(a.DocumentName);
				if (!byDoc.has(key)) byDoc.set(key, []);
				byDoc.get(key)!.push(a);
			}
			const enriched = rowsSource.map((r: any) => ({
				...r,
				Assemblies: byDoc.get(String(r.DocumentName)) ?? [],
			}));
			setListAssetDocuments(enriched);
			setIsAssetDocumentsLoading(false);
		} else {
			setIsAssetDocumentsLoading(false);
			setAssetDocumentsError(res.message);
		}
	};
};
